/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Italian (it) · Contact page
   English is the source of truth in contact.html; this file supplies the
   Italian counterpart for each contact.* data-i18n key. Missing keys fall
   back to English automatically (see i18n.js).

   House voice: calm, exact, short. No em dashes (use periods, commas,
   or the mid-dot · ). Product names (Transderma C/A/O/M/R, Discovery
   Kit, Moisture Serum) and the postal address stay as-is. Informal
   singular "tu" throughout.
═════════════════════════════════════════════════════════════════════ */
(function(){
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.it = window.TD_I18N.it || {};
  Object.assign(window.TD_I18N.it, {

    /* ── Footer · extra link not on the homepage ── */
    'footer.learn.about': 'Sul Dr. Ronlán',

    /* ── Page head ── */
    'contact.eyebrow': 'Mettiti in contatto',
    'contact.title': 'Domande,<br>richieste,<br><em>o solo un ciao.</em>',
    'contact.intro': 'Richieste stampa, richieste rivenditori, domande sulla routine, o qualsiasi cosa nel mezzo. Leggiamo ogni messaggio. Le risposte arrivano di solito entro due giorni lavorativi.',

    /* ── Reach us ── */
    'contact.reach': 'Come raggiungerci',
    'contact.email.label': 'E-mail',
    'contact.email.meta': 'Ideale per domande dettagliate',
    'contact.phone.label': 'Telefono',
    'contact.phone.meta': 'Lun – ven · 9–17 EST',
    'contact.address.label': 'Indirizzo',
    'contact.address.meta': 'Resi e corrispondenza',
    'contact.social.label': 'Trovaci sui social',

    /* ── Inquiry form ── */
    'contact.form.eyebrow': 'Invia una richiesta',
    'contact.form.name': 'Nome',
    'contact.form.subject': 'Oggetto',
    'contact.form.email': 'Indirizzo e-mail',
    'contact.form.message': 'Messaggio',
    'contact.form.send': 'Invia',
    'contact.form.success': 'Grazie per averci scritto · ti rispondiamo entro 1–2 giorni lavorativi.',

    /* ── Response windows ── */
    'contact.hours.eyebrow': 'Tempi di risposta',
    'contact.hours.email.label': 'E-mail',
    'contact.hours.email.val': 'Entro 2 giorni lavorativi',
    'contact.hours.phone.label': 'Telefono',
    'contact.hours.phone.val': '9–17 EST',
    'contact.hours.press.label': 'Stampa',
    'contact.hours.press.val': 'Entro 1 giorno lavorativo',

    /* ── CTA ── */
    'contact.cta.title': 'Non sai quale siero faccia per te?',
    'contact.cta.body': 'Il Discovery Kit contiene tutti e cinque i sieri in formato tascabile. La maggior parte lo capisce in pochi giorni.',
    'contact.cta.button': 'Ottieni il Discovery Kit'

  });
})();
